module.exports = __webpack_public_path__ + "static/media/comment-icon-green.53608309.svg";